<div class="collapsable-container"
     [ngStyle]="{
        'margin-top': '20px',
        'border-left': '4px solid #1976d2',
        'background': '#eef6ff'
     }">

    <!-- Header / Collapse -->
    <div class="collapsable-container-header" (click)="toggleCollapse()">
        <span class="btn-collapse" (click)="toggleCollapse()">
            <span class="fa fa-fw fa-angle-double-down"></span>
        </span>

        <div class="heading">{{ 'EOTPREMNICAOPASNAMATERIJA.SINGULAR' | translate }}</div>
    </div>

    <!-- Content -->
    <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">

        <!-- Inline Update Form -->
        <yt-eprijemnica-opasna-materija-update
            #baseUpdate>
        </yt-eprijemnica-opasna-materija-update>

        <!-- Buttons -->
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="btn-group float-right">
                    <button type="button"
                            class="btn btn-outline-primary"
                            (click)="Save()"
                            [disabled]="saveDisabled">
                        <span class="fa fa-save"></span> Sačuvaj
                    </button>

                    <button type="button"
                            class="btn btn-outline-primary"
                            (click)="Reset()">
                        <span class="fa fa-undo"></span> Odustani
                    </button>
                </div>
            </div>
        </div> -->

    </div>
</div>
